export default "__VITE_ASSET__CU3LQdSb__"